// src/contexts/ConferenceYearContext.js
import React, { createContext, useContext, useEffect, useState } from 'react';
import { supabase } from '../lib/supabase';

const DEFAULT_ACTIVE_YEAR = 2026;

const ConferenceYearContext = createContext({
  activeYear: DEFAULT_ACTIVE_YEAR,
  isLoading: true,
});

export const ConferenceYearProvider = ({ children }) => {
  const [activeYear, setActiveYear] = useState(DEFAULT_ACTIVE_YEAR);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    const loadActiveYear = async () => {
      try {
        const { data, error } = await supabase
          .from('conferences')
          .select('year')
          .eq('is_active', true)
          .single();

        if (!cancelled) {
          if (!error && data?.year) {
            setActiveYear(data.year);
          }
          setIsLoading(false);
        }
      } catch (err) {
        if (!cancelled) {
          setIsLoading(false);
        }
      }
    };

    loadActiveYear();

    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <ConferenceYearContext.Provider value={{ activeYear, isLoading }}>
      {children}
    </ConferenceYearContext.Provider>
  );
};

export const useConferenceYear = () => useContext(ConferenceYearContext);
